import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { endpoints } from "../../_config";
import { post, get } from "../../_services/apiService";
import { toast } from "react-toastify";
import OverLay from "../HomePage/OverLay";
import QuoteSummaryDetailPage from "./QuoteSummaryDetailPage";

const GetQuoteStep = () => {
    const [uploadedImage1, setUploadedImage1] = useState(null); // State for first file upload
    const [uploadedImage2, setUploadedImage2] = useState(null); // State for second file upload
    const [isChecked, setIsChecked] = useState(false);
    const [imageId, setImageId] = useState('0');
    const high_efficiency = localStorage.getItem("high_efficiency");

    const handleImageUpload1 = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setUploadedImage1(imageUrl); // Set the uploaded image URL for the first input
        }

        const { name, value, type } = event.target;

        if (type === 'file') {
            // For file inputs, store the selected file
            setFormData(prevState => ({
                ...prevState,
                [name]: event.target.files[0], // Handle file uploads
            }));
        }
    };
    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const handleImageUpload2 = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setUploadedImage2(imageUrl); // Set the uploaded image URL for the second input
        }


        const { name, value, type } = event.target;

        if (type === 'file') {
            // For file inputs, store the selected file
            setFormData(prevState => ({
                ...prevState,
                [name]: event.target.files[0], // Handle file uploads
            }));
        }

    };

    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 6; // Adjust this based on the number of steps
    const fieldsetsRef = useRef([]);
    const navigate = useNavigate(); // To handle navigation to /thankyou page


    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAppointmentSidebar, setShowAppointmentSidebar] = useState(false);
    const [activeTab, setActiveTab] = useState('book-appointment');
    const [serviceTypeData, setServiceTypeData] = useState();
    const [getSizeTypeData, setGetSizeType] = useState();
    const [getSizeTypeDetails, setGetSizeTypeDetails] = useState();
    const isSizeDetailInitialized = useRef(false);

    const [formShowData, setFormShowData] = useState([
        { label: "High Efficiency", name: "high_efficiency", value: "No" },
        // { label: "Furnace Size", name: "furnaceSize", value: "" },
        { label: "Replacement Option", name: "serviceId", value: "" },
        { label: "Above grade sqft of house", name: "sizeTypeId", value: "" },
        { label: "Anything Else We Need To Know", name: "additionalMsg", value: "N/A" },
    ]);

    const onContactUs = (activetab) => {
        setShowAppointmentSidebar(true);
        setActiveTab(activetab);
    }

    const sizeData = [
        { sizeId: '14\"', sizeName: '14\"' },
        { sizeId: '17\"', sizeName: '17\"' },
        { sizeId: '21\"', sizeName: '21\"' },
        { sizeId: '24\"', sizeName: '24\"' },
    ];

    const validateStep = (step) => {
        switch (step) {
            case 1:
                if (!formData.streetAddress) {
                    toast.warning("Please enter your address");
                    return false;
                }
                return true;
            case 2:
                if (!formData.additionalMsg || formData.additionalMsg.trim() === "") {
                    toast.warning("Please provide system details");
                    return false;
                }
                return true;
            case 3:
                if (!formData.high_efficiency && formData.high_efficiency !== 0) {
                    toast.warning("Please select High Efficiency option");
                    return false;
                }
                if (!formData.size) {
                    toast.warning("Please select furnace size");
                    return false;
                }
                return true;
            case 4:
                if (!formData.serviceId || formData.serviceId === 0) {
                    toast.warning("Please select a replacement option");
                    return false;
                }
                if (!formData.sizeTypeId || formData.sizeTypeId === 0) {
                    toast.warning("Please select Above Grade Sqft of house");
                    return false;
                }
                return true;
            case 5:
                // Optional: you can validate summary step if needed
                return true;
            case 6:
                if (!formData.firstName || !formData.emailId || !formData.contactNo) {
                    toast.warning("Please fill required info and check terms & conditions");
                    return false;
                }
                return true;
            default:
                return true;
        }
    };

    // const handleNext = () => {
    //     if (currentStep < totalSteps) {
    //         animateFieldset(currentStep - 1, currentStep, true);
    //         setCurrentStep(currentStep + 1);
    //     } else if (currentStep === totalSteps) {

    //         onQuotation();
    //         // Redirect to /thankyou when at the last step
    //         // Trigger the redirect when the user reaches step 4

    //     }
    // };

    const handleNext = () => {
        if (!validateStep(currentStep)) return; // Stop if validation fails

        if (currentStep < totalSteps) {
            animateFieldset(currentStep - 1, currentStep, true);
            setCurrentStep(currentStep + 1);
        } else if (currentStep === totalSteps) {
            onQuotation();
        }
    };

    const handlePrevious = () => {
        if (currentStep > 1) {
            animateFieldset(currentStep - 1, currentStep - 2, false);
            setCurrentStep(currentStep - 1);
        }

    };

    const animateFieldset = (fromIndex, toIndex, isNext) => {
        const fromFieldset = fieldsetsRef.current[fromIndex];
        const toFieldset = fieldsetsRef.current[toIndex];

        if (!fromFieldset || !toFieldset) return;

        fromFieldset.style.opacity = 0;
        setTimeout(() => {
            fromFieldset.style.display = "none";
            toFieldset.style.display = "block";
            toFieldset.style.opacity = 1;
        }, 400);
    };

    const getProgressWidth = () => {
        return `${(currentStep / totalSteps) * 100}%`;
    };

    const [formData, setFormData] = useState({
        quotationId: 0,
        firstName: '',
        lastName: '',
        emailId: '',
        contactNo: "",
        referralSource: "",
        additionalMsg: "",
        serviceId: 0,
        streetAddress: '',
        modelNumber: '',
        sizeTypeId: 0,
        productDetail: '',
        state: "",
        isActive: true,
        createdBy: 0,
        aboveGroundLevel: '',
        preferredDay1: '',
        time1: '',
        preferredDay2: '',
        time2: '',
        serialImagePath: '',
        productPath: '',
        houseStatusId: 1,
        file: '',
        fullfile: '',
        sysType: '',
        size: '',
        sizedetailsId: "",
        high_efficiency: 0
    });

    useEffect(() => {
        if (
            getSizeTypeDetails?.length > 0 &&
            !isSizeDetailInitialized.current
        ) {
            const firstItem = getSizeTypeDetails[0];
            const optionValue = `${firstItem?.details}`;

            setFormData((prev) => ({
                ...prev,
                sizedetailsId: optionValue,
            }));

            // ✅ mark as initialized
            isSizeDetailInitialized.current = true;
        }
    }, [getSizeTypeDetails, formData.size]);

    useEffect(() => {
        isSizeDetailInitialized.current = false;
    }, [formData.sizeTypeId, formData.high_efficiency]);


    // ✅ Set default first size automatically when data arrives
    useEffect(() => {
        if (sizeData.length > 0 && !formData.size) {
            setFormData((prev) => ({
                ...prev,
                size: sizeData[0].sizeId
            }));

            // ✅ Also update formShowData (so it shows the default size)
            setFormShowData((prev) =>
                prev.map((field) =>
                    field.name === "furnaceSize"
                        ? { ...field, value: sizeData[0].sizeId }
                        : field
                )
            );
        }
    }, [sizeData, formData]);

    useEffect(() => {
    localStorage.removeItem("high_efficiency");
}, []);


    const getServiceType = async () => {
        try {
            const response = await get(endpoints.GetServiceType)
            if (response.isSuccess === 200) {
                setServiceTypeData(response.data);
            } else {
                setError("Failed to fetch Service Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const getSizeType = async () => {
        try {
            const response = await get(endpoints.GetSizeType)
            if (response.isSuccess === 200) {
                setGetSizeType(response.data);
            } else {
                setError("Failed to fetch Size Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const getSizeTypeServiceId = async (serviceId) => {
        try {
            const response = await get(`${endpoints.GetSizeTypeByServiceId}/${serviceId}`);
            if (response.isSuccess === 200) {
                setGetSizeType(response.data);
            } else {
                setError("Failed to fetch Size Type");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const getSizeTypeDetails = async () => {

            if (formData.sizeTypeId === 0) {
                return;
            }

            try {
                const response = await get(`${endpoints.GetSizeTypeDetails}/${formData.sizeTypeId}`);
                if (response.isSuccess === true) {

                    const filteredData = response?.data?.filter(item => Number(item?.is_high_efficiency) === Number(high_efficiency ? high_efficiency : 0))

                    if (filteredData?.length > 0) {
                        setGetSizeTypeDetails(filteredData);
                    } else {
                        localStorage.removeItem("high_efficiency");
                        setGetSizeTypeDetails(response?.data)
                    }

                } else {
                    setError("Failed to fetch Size Type");
                }
            } catch (error) {
                setError("Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        getSizeTypeDetails();
    }, [formData, high_efficiency])

    useEffect(() => {
        getServiceType();
        // getSizeType();
    }, []);

    const handleChange = async (e) => {
        const { name, value, type } = e.target;

        // ✅ Handle High Efficiency separately
        if (name === "high_efficiency") {
            const numericValue = value === "Yes" ? 1 : 0;
            localStorage.setItem("high_efficiency", numericValue)

            // Update formData
            setFormData((prev) => ({
                ...prev,
                [name]: numericValue,
            }));

            // Update formShowData (match the same name key)
            setFormShowData((prev) =>
                prev.map((field) =>
                    field.name === "high_efficiency"
                        ? { ...field, value } // show Yes or No
                        : field
                )
            );

            return;
        }

        // ✅ Continue for other fields
        setFormData((prev) => ({
            ...prev,
            [name]: type === "file" ? e.target.files[0] : value,
        }));

        setFormShowData((prev) => {
            let updated = [...prev];

            if (name === "serviceId") {
                const selectedService = serviceTypeData?.find(
                    (s) => s.serviceId.toString() === value
                );
                updated = updated.map((field) =>
                    field.name === "serviceId"
                        ? { ...field, value: selectedService?.serviceName || "" }
                        : field
                );
            } else if (name === "sizeTypeId") {
                const selectedSize = getSizeTypeData?.find(
                    (s) => s.sizeTypeId.toString() === value
                );
                updated = updated.map((field) =>
                    field.name === "sizeTypeId"
                        ? { ...field, value: selectedSize?.typeName || "" }
                        : field
                );
            } else if (name === "size") {
                updated = updated.map((field) =>
                    field.name === "furnaceSize" ? { ...field, value } : field
                );
            } else {
                updated = updated.map((field) =>
                    field.name === name ? { ...field, value } : field
                );
            }

            return updated;
        });

        // ✅ Load size type options dynamically
        if (name === "serviceId") {
            setFormData((prev) => ({ ...prev, sizeTypeId: 0 }));
            if (value !== "0") await getSizeTypeServiceId(value);
            else setGetSizeType([]);
        }
    };

    // useEffect(() => {
    //     if (!high_efficiency) {
    //         localStorage.setItem("high_efficiency", 0)
    //     }
    // }, [high_efficiency])

    const onQuotation = async () => {

        if (isChecked) {
            const formDataToSend = new FormData();

            // Append form data fields
            for (const key in formData) {
                formDataToSend.append(key, formData[key]);
            }

            setLoading(true)
            try {
                const response = await post(endpoints.SaveQuatation, formDataToSend);
                if (response.isSuccess === 200) {

                    toast.success("Quotation submit successfully");
                    onReset();

                    setTimeout(() => {
                        navigate("/thank-you");
                    }, 2000);
                    localStorage.removeItem("high_efficiency");
                } else {
                    toast.error("Failed to submit form data");
                }
            } catch (error) {
                toast.error("Please try again later.");
            } finally {
                setLoading(false)
            }
        } else {
            toast.warning("Please check terms & condition");

        }
    };


    const onReset = () => {
        setFormData({
            quotationId: 0,
            firstName: '',
            lastName: '',
            emailId: '',
            contactNo: "",
            referralSource: "",
            additionalMsg: "",
            serviceId: 0,
            streetAddress: '',
            modelNumber: '',
            sizeTypeId: 0,
            productDetail: '',
            state: "",
            isActive: true,
            createdBy: 0,
            aboveGroundLevel: '',
            preferredDay1: '',
            time1: '',
            preferredDay2: '',
            time2: '',
            serialImagePath: '',
            productPath: '',
            houseStatusId: 1,
            file: '',
            fullfile: '',
            sysType: '',
            size: ''
        });
    }

    const [selectedOptions, setSelectedOptions] = useState({
        crawlspace: false,
        attic: false,
        mechanical: false,
        multipleSystem: false,
    });

    const handleCheckboxChange1 = (event) => {
        const { name, checked } = event.target;

        // Update the selected options state
        setSelectedOptions((prevState) => ({
            ...prevState,
            [name]: checked,
        }));

        // Update sysType with a comma-separated list
        setFormData((prevState) => {
            // Ensure sysType is initialized to an empty string if it doesn't exist
            let newSysType = prevState.sysType ? prevState.sysType.split(",") : [];

            if (checked) {
                // Add the name to sysType if it isn't already present
                if (!newSysType.includes(name)) {
                    newSysType.push(name);
                }
            } else {
                // Remove the name from sysType if it's unchecked
                newSysType = newSysType.filter((item) => item !== name);
            }

            // Join the sysType list into a comma-separated string
            return {
                ...prevState,
                sysType: newSysType.join(","),
            };
        });

    };

    const [isModal1Visible, setIsModal1Visible] = useState(false);
    const [isModal2Visible, setIsModal2Visible] = useState(false);
    const [isModal3Visible, setIsModal3Visible] = useState(false);


    // Function to handle hover event

    const handleMouseEnter3 = () => {
        setIsModal3Visible(true); // Show modal when hovered
    };

    const handleMouseEnter2 = () => {
        setIsModal2Visible(true); // Show modal when hovered
    };

    const handleMouseEnter1 = () => {
        setIsModal1Visible(true); // Show modal when hovered
    };

    const handle3MouseLeave = () => {
        setIsModal3Visible(false); // Hide modal when mouse leaves
    };

    const handle1MouseLeave = () => {
        setIsModal1Visible(false); // Hide modal when mouse leaves
    };

    const handle2MouseLeave = () => {
        setIsModal2Visible(false); // Hide modal when mouse leaves
    };

    return (
        <section className="get_quote_wepper">
            {/* Book Appointment */}
            <section className="over_lay">
                <OverLay
                    showAppointmentSidebar={showAppointmentSidebar}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setShowAppointmentSidebar={setShowAppointmentSidebar}

                />
            </section>

            <div
                className="card"
                style={{
                    background: currentStep === 5
                        ? "#ffffff" // ✅ background color when step = 5
                        : "url('images/step1.png') no-repeat center/cover" // ✅ image otherwise
                }}
            >
                <form id="msform" onSubmit={onQuotation} className="container"
                    style={{
                        padding: currentStep === 5
                            ? "0"
                            : "",
                        maxWidth: currentStep === 5 ? '100%' : '1100px'
                    }}
                >

                    {/* Step 1 */}
                    <fieldset
                        ref={(el) => (fieldsetsRef.current[0] = el)}
                        style={{ display: currentStep === 1 ? "block" : "none" }}
                    >
                        <div className="form-card">
                            <div className="logo_currnt">
                                <img src="images/logo-white-text.png" alt="" />
                            </div>
                            {/* <p className="step_first">
                                The first step in receiving your detailed quote is telling us some basic information. This process will only take a couple of minutes.
                            </p> */}
                            <p className="step_first">
                                Ready for a quote? The first step is providing some basic information. This quick process takes only a few minutes.
                            </p>
                            <h2 id="heading">Enter the address where you need help.... </h2>
                            <div className="form-group email_wepper email_wepper_Address placeholder_color_chnge">
                                <label className="fieldlabels">
                                    Enter Your Address <span>|</span>
                                </label>

                                <input type="text" name="streetAddress" id="streetAddress" className="form-control" placeholder="Denver W Pkwy, Golden, CO 80401" required value={formData.streetAddress} onChange={handleChange} />



                            </div>
                            <div className="example_wepper">
                                <span>
                                    Your privacy is important to us. The information you provide is strictly confidential and will only be used to create your detailed quote
                                </span>
                            </div>
                        </div>
                    </fieldset>

                    {/* Step 2 */}
                    <fieldset
                        ref={(el) => (fieldsetsRef.current[1] = el)}
                        style={{ display: currentStep === 2 ? "block" : "none" }}
                    >
                        <div className="form-card">
                            <h2 id="heading">Tell us what's happening with your system.</h2>
                            <p>
                                Since everyone system is different, a few details will help us understand the issue and provide the best solution.
                            </p>
                            <div className="form-group email_wepper what_going">

                                <textarea name="additionalMsg" id="additionalMsg" rows="4" data-name="Message" placeholder="What's going on?" value={formData.additionalMsg} onChange={handleChange}
                                    className="form-control" required=""></textarea>
                            </div>
                            <div className="example_wepper sure_whate">
                                <p>Example: My Furnace is not blowing warm air</p>
                                <span>Example: Our system is 24 years old and need a quote to replace</span>
                            </div>
                            <div className="example_wepper">
                                <span>Your privacy is important to us. The information you provide is strictly confidential and will only be used to create your detailed quote</span>
                            </div>
                        </div>
                    </fieldset>

                    {/* Step 3 */}
                    <fieldset
                        style={{ display: currentStep === 3 ? "block" : "none" }}
                    >
                        <div className="form-card">
                            <h2 id="heading">Share the details of your HVAC system</h2>
                            <div className="row mt-5 justify-content-center">
                                {/* First File Upload */}

                                <div className="col-xxl-6 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                    <div className="what_going_content file_uplode_quote">


                                        <label className="filelabel">
                                            <img
                                                src={uploadedImage1 || "images/album.svg"} // Show uploaded image or default icon
                                                alt="Uploaded Preview 1"
                                                style={{ width: "80px", height: "80px", borderRadius: "7px" }} // Set width and height
                                            />


                                            <span className="title">
                                                Upload a picture

                                                <span className="info_photo"
                                                    onMouseEnter={handleMouseEnter1}
                                                    onMouseLeave={handle1MouseLeave}

                                                >
                                                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_2499_3)">
                                                            <path d="M17.9253 3.07525C13.8247 -1.02486 7.17628 -1.02531 3.07525 3.07525C-1.02531 7.17582 -1.02486 13.8243 3.07525 17.9253C7.17582 22.025 13.8243 22.0254 17.9253 17.9253C22.0254 13.8243 22.025 7.17628 17.9253 3.07525ZM11.8694 15.0656C11.8694 15.8221 11.2563 16.4352 10.4998 16.4352C9.74335 16.4352 9.13023 15.8221 9.13023 15.0656V9.58722C9.13023 8.83075 9.74335 8.21763 10.4998 8.21763C11.2563 8.21763 11.8694 8.83075 11.8694 9.58722V15.0656ZM10.4756 7.24613C9.68674 7.24613 9.16082 6.68733 9.17725 5.99751C9.16082 5.27437 9.68674 4.73246 10.4916 4.73246C11.2969 4.73246 11.8064 5.27482 11.8233 5.99751C11.8229 6.68733 11.2974 7.24613 10.4756 7.24613Z" fill="black" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_2499_3">
                                                                <rect width="21" height="21" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </span>
                                            </span>
                                            <p>of your AC Model/Serial Sticker</p>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="file"
                                                name="file"
                                                accept="image/png, image/jpeg"
                                                onChange={handleImageUpload1} // Handle first file upload
                                            />
                                        </label>
                                    </div>
                                </div>

                                {/* Second File Upload */}
                                <div className="col-xxl-6 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                    <div className="what_going_content file_uplode_quote">
                                        <label className="filelabel">
                                            <img
                                                src={uploadedImage2 || "images/phone.svg"} // Show uploaded image or default icon
                                                alt="Uploaded Preview 2"
                                                style={{ width: "80px", height: "80px", borderRadius: "7px" }} // Set width and height
                                            />

                                            <span className="title">
                                                Upload a picture
                                                <span className="info_photo"
                                                    onMouseEnter={handleMouseEnter2}
                                                    onMouseLeave={handle2MouseLeave}

                                                >
                                                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_2499_3)">
                                                            <path d="M17.9253 3.07525C13.8247 -1.02486 7.17628 -1.02531 3.07525 3.07525C-1.02531 7.17582 -1.02486 13.8243 3.07525 17.9253C7.17582 22.025 13.8243 22.0254 17.9253 17.9253C22.0254 13.8243 22.025 7.17628 17.9253 3.07525ZM11.8694 15.0656C11.8694 15.8221 11.2563 16.4352 10.4998 16.4352C9.74335 16.4352 9.13023 15.8221 9.13023 15.0656V9.58722C9.13023 8.83075 9.74335 8.21763 10.4998 8.21763C11.2563 8.21763 11.8694 8.83075 11.8694 9.58722V15.0656ZM10.4756 7.24613C9.68674 7.24613 9.16082 6.68733 9.17725 5.99751C9.16082 5.27437 9.68674 4.73246 10.4916 4.73246C11.2969 4.73246 11.8064 5.27482 11.8233 5.99751C11.8229 6.68733 11.2974 7.24613 10.4756 7.24613Z" fill="black" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_2499_3">
                                                                <rect width="21" height="21" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </span>
                                            </span>

                                            <p>of Your furnace from 5ft Back and measure the width</p>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="fullfile"
                                                name="fullfile"
                                                accept="image/png, image/jpeg"
                                                onChange={handleImageUpload2} // Handle second file upload
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className="checkboxes__row mt-4">
                                    <span
                                        onMouseEnter={handleMouseEnter3}
                                        onMouseLeave={handle3MouseLeave}
                                        className="high_efficincy"
                                    >
                                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_2499_3)">
                                                <path d="M17.9253 3.07525C13.8247 -1.02486 7.17628 -1.02531 3.07525 3.07525C-1.02531 7.17582 -1.02486 13.8243 3.07525 17.9253C7.17582 22.025 13.8243 22.0254 17.9253 17.9253C22.0254 13.8243 22.025 7.17628 17.9253 3.07525ZM11.8694 15.0656C11.8694 15.8221 11.2563 16.4352 10.4998 16.4352C9.74335 16.4352 9.13023 15.8221 9.13023 15.0656V9.58722C9.13023 8.83075 9.74335 8.21763 10.4998 8.21763C11.2563 8.21763 11.8694 8.83075 11.8694 9.58722V15.0656ZM10.4756 7.24613C9.68674 7.24613 9.16082 6.68733 9.17725 5.99751C9.16082 5.27437 9.68674 4.73246 10.4916 4.73246C11.2969 4.73246 11.8064 5.27482 11.8233 5.99751C11.8229 6.68733 11.2974 7.24613 10.4756 7.24613Z" fill="black" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_2499_3">
                                                    <rect width="21" height="21" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                    High Efficiency
                                    {["Yes", "No"].map((option) => (
                                        <div
                                            key={option}
                                            className={`radio_buttons__item ${formData.high_efficiency === (option === "Yes" ? 1 : 0) ? "active" : ""
                                                }`}
                                        >
                                            <input
                                                type="radio"
                                                name="high_efficiency"
                                                value={option}
                                                checked={formData.high_efficiency === (option === "Yes" ? 1 : 0)}
                                                onChange={handleChange}
                                            />
                                            <div className="radio__checkmark"></div>
                                            <div className="radio__body">{option}</div>
                                        </div>
                                    ))}
                                </div>

                                <div className="checkboxes__row mt-1 d-sm-flex d-block">
                                    <div className="m-0 text-start mt-0 mb-2">Select the size your furnace</div>
                                    <div className="d-flex">
                                        {sizeData?.map((item) => (
                                            <div
                                                key={item.sizeId}
                                                className={`radio_buttons__item ${formData.size == item.sizeId ? "active" : ""
                                                    }`}
                                            >
                                                <input
                                                    type="radio"
                                                    name="size"
                                                    value={item.sizeId}
                                                    checked={formData.size == item.sizeId}
                                                    onChange={handleChange}
                                                />
                                                <div className="radio__checkmark"></div>
                                                <div className="radio__body">{item.sizeName}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <p className="your_information">
                                    Your privacy is important to us. The information you provide is strictly confidential and will only be used to create your detailed quote.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    {/* Step 4 */}
                    <fieldset
                        ref={(el) => (fieldsetsRef.current[3] = el)}
                        style={{ display: currentStep === 4 ? "block" : "none" }}
                    >
                        <div className="form-card" />
                        <h2 id="heading" className="mb-4">Tell us about your current HVAC system</h2>

                        <div className="row mt-1">
                            <div className="wepper_serive_select row">
                                <div className="col-xxl-6 col-xl-126 col-lg-6 col-md-6 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper send_quote_wepper_select">
                                        <select
                                            name="serviceId"
                                            id="serviceId"
                                            value={formData.serviceId}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="0">Select Replacement Option</option>
                                            {serviceTypeData?.map(item => (
                                                <option key={item.serviceId} value={item.serviceId}>
                                                    {item.serviceName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-126 col-lg-6 col-md-6 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper send_quote_wepper_select">
                                        <select
                                            name="sizeTypeId"
                                            id="sizeTypeId"
                                            value={formData.sizeTypeId}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="0">Above Grade Sqft of house</option>
                                            {getSizeTypeData?.map(item => (
                                                <option key={item.sizeTypeId} value={item.sizeTypeId}>
                                                    {item.typeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper send_quote_textarea">
                                        <div className="checkbox-group">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="attic"
                                                    checked={selectedOptions.attic}
                                                    onChange={handleCheckboxChange1}
                                                />
                                                Attic
                                            </label>
                                            <label >
                                                <input
                                                    type="checkbox"
                                                    name="crawlspace"
                                                    checked={selectedOptions.crawlspace}
                                                    onChange={handleCheckboxChange1}
                                                />
                                                Crawlspace
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="mechanical"
                                                    checked={selectedOptions.mechanical}
                                                    onChange={handleCheckboxChange1}
                                                />
                                                Mechanical Room
                                            </label>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="multipleSystem"
                                                    checked={selectedOptions.multipleSystem}
                                                    onChange={handleCheckboxChange1}
                                                />
                                                Multiple Systems
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper send_quote_textarea">
                                        <textarea name="productDetail" id="productDetail" rows="3" data-name="Message" placeholder="Other product information" value={formData.productDetail} onChange={handleChange}
                                            className="form-control" required=""></textarea>
                                    </div>
                                </div>
                            </div>
                            <p className="your_information">Your privacy is important to us. The information you provide is strictly confidential and will only be used to create your detailed quote.</p>
                        </div>
                    </fieldset>

                    {/* Step 5 */}
                    <fieldset
                        ref={(el) => (fieldsetsRef.current[4] = el)}
                        style={{ display: currentStep === 5 ? "block" : "none" }}
                    >
                        <QuoteSummaryDetailPage formShowData={formShowData} getSizeTypeDetails={getSizeTypeDetails} handleChange={handleChange} formData={formData} handleNext={handleNext} onContactUs={onContactUs} />
                    </fieldset>

                    {/* Step 6 */}
                    <fieldset
                        ref={(el) => (fieldsetsRef.current[5] = el)}
                        style={{ display: currentStep === 6 ? "block" : "none" }}
                    >
                        <div className="form-card">
                            <h2 id="heading">Almost done...</h2>
                            <p>
                                Please give us your information so that we will be able to send you our quote.
                            </p>
                            <div className="row mt-2">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper">
                                        <input
                                            type="text"
                                            name="firstName"
                                            id="firstName"
                                            className="form-control"
                                            placeholder="First Name"
                                            required
                                            value={formData.firstName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper">
                                        <input
                                            type="text"
                                            name="lastName"
                                            id="lastName"
                                            className="form-control"
                                            placeholder="Last Name"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper">
                                        <input
                                            type="text"
                                            name="emailId"
                                            id="emailId"
                                            className="form-control"
                                            placeholder="Email Address"
                                            required
                                            value={formData.emailId}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper">
                                        <input
                                            type="text"
                                            name="contactNo"
                                            id="contactNo"
                                            className="form-control"
                                            placeholder="Phone Number"
                                            value={formData.contactNo}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                                    <div className="send_quote_wepper">
                                        <input
                                            type="text"
                                            name="referralSource"
                                            id="referralSource"
                                            className="form-control"
                                            placeholder="How did you hear about us?"
                                            value={formData.referralSource}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="checkbox_once">
                                    <label >
                                        <input
                                            type="checkbox"
                                            name="agree"
                                            id="agree"
                                            required
                                            className="me-2"
                                            onChange={handleCheckboxChange} // Add this to handle checkbox state
                                        />

                                    </label>
                                    <p className="your_information text-start">  Once you click submit you <span>Agree</span> to receive information and communication from us about your quote and as always your information is kept private.</p>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>

                {/* Progress Bar */}
                {currentStep !== 5 && (
                    <div className="progress">
                        <div
                            className="progress-bar progress-bar-striped"
                            style={{ width: getProgressWidth() }}
                        ></div>
                    </div>
                )}

                {/* Dynamic Step Display */}
                <div className="container" style={{
                    maxWidth: currentStep === 5 ? '' : '1100px'
                }}>
                    <div className="row setp_wepper">
                        <div className="col-lg-6 col-sm-6 col-12">
                            {/* Conditionally render "Previous Page" button */}
                            {currentStep > 1 && (
                                <div className="previous_wepper">
                                    <span onClick={handlePrevious} className={`${currentStep === 5 ? 'span2' : 'span1'}`}>
                                        <img src="images/preview-icon.png" alt="" /> Previous Page
                                    </span>
                                    {currentStep !== 5 && (
                                        <button style={{ background: 'transparent' }} onClick={() => onContactUs('contact-us')} className={`${currentStep === 5 ? 'fs-title1' : 'fs-title'}`} >Connect with us </button>
                                    )}
                                </div>
                            )}
                        </div>
                        {currentStep !== 5 && (
                            <div className="col-lg-6 col-sm-6 col-12">
                                <div className={`${currentStep === 5 ? 'steps1' : 'steps'}`}>
                                    Step {currentStep} {/* Dynamic step number */}
                                    <p className="next action-button" onClick={handleNext}>

                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            currentStep === 6 ? "Submit" : "Continue"
                                        )}
                                        {currentStep !== 6 && <img src="images/right-arrow.svg" alt="" />}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {isModal3Visible && (
                <div className="model_popup2">
                    <span >
                        <img src="images/highefficiency.jpeg" alt="" />
                    </span>
                </div>
            )}

            {isModal1Visible && (
                <div className="model_popup1">
                    <span >
                        <img src="images/productimage.jpeg" alt="" />
                    </span>
                </div>
            )}
            {isModal2Visible && (
                <div className="model_popup2">
                    <span >
                        <img src="images/serialno.jpeg" alt="" />
                    </span>
                </div>
            )}
        </section>
    );



};



export default GetQuoteStep;
